// eslint-disable-next-line @typescript-eslint/no-explicit-any
const switchPanes = (gm: any): boolean => {
  try {
    const { panes } = gm;
    const { markerLayer } = panes;
    const { floatPane } = panes;

    floatPane.appendChild(markerLayer);
    markerLayer.style.pointerEvents = 'none';

    return true;
  } catch (err) {
    return false;
  }
};
export default switchPanes;
